<template>
  <transition name="fade">
    <div
      v-if="showOverlay"
      class="wrapper shadow-xl rounded-lg p-2 cart-overlay"
      @mouseover="setOverlayTimeout(oneDay)"
      @mouseleave="setOverlayTimeout(threeSeconds)"
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        <p class="h5 mb-0">{{ translations.cart }}</p>
        <button class="btn btn-reset p-0" @click="toggleShowOverlay">
          <Close class="svg-fill-dark svg-24" />
        </button>
      </div>
      <div v-if="lineItems.length > 0" class="mb-1 scroll-wrapper">
        <div class="py-2 scroll-content">
          <ShoppingCartLineItem
            v-for="lineItem in lineItems"
            :key="lineItem.variant.id"
            :line-item="lineItem"
            :translations="translations"
          />
        </div>
      </div>
      <div v-else class="mb-2">
        {{ translations.empty_cart }}
      </div>
      <a v-if="cartPath" class="mb-1 btn btn-sm btn-block btn-secondary" :href="cartPath">{{
        translations.go_to_cart
      }}</a>
      <a v-if="checkoutPath" class="btn btn-sm btn-block btn-secondary-link" :href="checkoutPath">{{
        translations.go_to_checkout
      }}</a>
    </div>
  </transition>
</template>

<script>
import ShoppingCartLineItem from "./ShoppingCartLineItem";
import Close from "../../../icons/atalanda/close.svg";

import { mapGetters, mapActions } from "vuex";

export default {
  components: { ShoppingCartLineItem, Close },
  props: {
    translations: {
      type: Object,
      required: true,
    },
    checkoutPath: {
      type: String,
      default: "",
    },
    cartPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      oneDay: 1000 * 60 * 60 * 24,
      threeSeconds: 1000 * 3,
    };
  },
  computed: {
    ...mapGetters({
      lineItems: "shoppingCart/getAllLineItems",
      showOverlay: "shoppingCart/showOverlay",
      visibilityTimeout: "shoppingCart/visibilityTimeout",
    }),
  },
  methods: {
    ...mapActions({
      toggleShowOverlay: "shoppingCart/toggleShowOverlay",
      showOverlayFor: "shoppingCart/showOverlayFor",
    }),
    setOverlayTimeout(time) {
      if (this.visibilityTimeout) {
        this.showOverlayFor(time);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration, transform $transition-duration;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY($spacer);
}

.wrapper {
  position: fixed;
  width: auto;
  background: $white;
  top: $spacer / 4;
  right: $spacer / 4;
  left: $spacer / 4;
  z-index: $zi-highest;

  @media (min-width: $screen-sm-min) {
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    width: $width-cart-overlay;
    margin: 0;

    &::before {
      z-index: $zi-highest;
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid $white;
      position: absolute;
      right: 20px;
      top: -10px;
    }
  }
}

.scrolling-touch {
  -webkit-overflow-scrolling: touch;
}

.scroll-content {
  max-height: $max-height-cart-overlay-xs;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;

  @media (min-width: $screen-sm-min) {
    max-height: $max-height-cart-overlay;
  }
}

.scroll-wrapper {
  position: relative;

  &::after {
    background-image: linear-gradient(to bottom, rgba($white, 0), rgba($white, 1) 100%);
    bottom: 0;
    content: "";
    height: $spacer;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: $zi-higher;
  }
}
</style>
